module.exports = __webpack_public_path__ + "static/img/BIOMATDB.15b90df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BIOMATDB.png
// module id = q+06
// module chunks = 1